import type { ReactNode } from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

interface AdminPageShellProps {
  /** @deprecated Title is shown in AppHeader via getPageTitle(); kept for API compatibility */
  title?: string;
  description?: string;
  actions?: ReactNode;
  isLoading?: boolean;
  error?: Error | null;
  children: ReactNode;
}

export function AdminPageShell({
  description,
  actions,
  isLoading,
  error,
  children,
}: AdminPageShellProps) {
  const { setOpenMobile } = useSidebar();
  const showToolbar = description || actions;

  return (
    <div className={cn("space-y-6 p-4 md:p-6 lg:p-8")}>
      <div
        className={cn(
          "flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between",
          !showToolbar && "lg:hidden",
        )}
      >
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            onClick={() => setOpenMobile(true)}
            aria-label="فتح القائمة الجانبية"
          >
            <Menu className="h-5 w-5" />
          </Button>
          {description && (
            <p className="text-right text-sm text-muted-foreground md:text-base">
              {description}
            </p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>

      {isLoading && (
        <div className="flex justify-center py-16">
          <Spinner className="size-8" />
        </div>
      )}

      {!isLoading && error && (
        <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-right text-red-700">
          {error.message || "حدث خطأ أثناء تحميل البيانات"}
        </div>
      )}

      {!isLoading && !error && children}
    </div>
  );
}
